// As N sugestões mais importantes, com aplicar / agora não (contrato de UI: { companyId, limit? }).
import { Link } from 'react-router-dom'
import { useCompanyQuery } from '../../lib/company'
import { useConnections } from '../connections/api'
import { ErrorState, Loading } from '../../ui'
import { useRecommendations } from './api'
import SuggestionCard from './SuggestionCard'

export default function TopSuggestions({ companyId, limit = 3 }: { companyId: string; limit?: number }) {
  const q = useRecommendations(companyId, 'open')
  const company = useCompanyQuery(companyId)
  const connections = useConnections(companyId)
  const canConnect = !!company.data?.access.permissions.includes('company.manage_connections')
  const canApply = !!company.data?.access.permissions.includes('company.apply_suggestion')
  if (q.isLoading) return <Loading lines={3} />
  if (q.isError) return <ErrorState error={q.error} onRetry={() => void q.refetch()} />
  const items = q.data?.items.slice(0, limit) ?? []
  if (!items.length && connections.data && connections.data.items.length === 0) {
    // sem conta conectada não há o que analisar: não dizer que está tudo certo
    return (
      <div className="card empty">
        <p>Ainda não analisamos nada: nenhuma conta de anúncios está conectada.</p>
        {canConnect && <Link className="btn primary sm mt-12" to={`/app/${companyId}/contas`}>Conectar contas</Link>}
      </div>
    )
  }
  if (!items.length) {
    return (
      <div className="card empty">
        <p>Tudo em ordem por aqui. Analisamos suas contas todos os dias e avisamos quando surgir uma oportunidade.</p>
      </div>
    )
  }
  return (
    <div className="stack">
      <div className="list">
        {items.map((s) => <SuggestionCard key={s.id} s={s} companyId={companyId} compact canApply={canApply} />)}
      </div>
      {(q.data?.summary.open ?? 0) > items.length && (
        <Link className="btn ghost sm" to={`/app/${companyId}/sugestoes`}>Ver todas as {q.data!.summary.open} sugestões</Link>
      )}
    </div>
  )
}
